import { useState, useEffect } from "react";
import Layout from "../components/Layout";
import NextHead from "../components/Seo/NextHead";
import BreadcrumbComponent from "../components/UserInterface/BreadcrumbComponent";
import { blogBreadcrumb, defBreadcrumb } from "../data/DataBreadcrumb";
import { BlogTitle } from "../components/BlogPost/BlogTitle";
import { SocialMediaShareBar } from "../components/SocialMedia/SocialMediaShareBar";
import { BlogWysiwyg } from "../components/BlogPost/BlogWysiwyg";
import fetch from "../utils/fetch";
import LayoutCenter from "../components/UserInterface/LayoutCenter";
import UseWindowSize from "../components/UseWindowSize";
import { scrollDetector } from "../utils/scroll-detector";
import BlogRelatedArticle from "../components/Blog/BlogRelatedArticle";
import BlogCTA from "../components/Blog/BlogCTA";
import { BlogIframe } from "src/components/BlogPost/BlogIrame";
import { BlogOtherCategory } from "src/components/Blog/BlogOtherCategory";

const detailBlog = ({ datas }) => {
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);
  useEffect(() => {
    setWinSize(width);
    scrollDetector("sticky-share-socmend", "socmed-share-wrapper");
  }, []);
  const { asPath, data, itemsForBreadCrumb, breadcrumb } = datas;

  return (
    <Layout>
      <NextHead
        title={data.meta_title || data.title}
        description={data.meta_desc}
        url={asPath}
        breadcrumb={breadcrumb}
        imgContent={data.banner}
      ></NextHead>
      <BreadcrumbComponent items={itemsForBreadCrumb} maxWidth="1040px" />
      <div className="blog-wrapper">
        <div className="blog-content-container">
          <div className="blog-content">
            <div className="blog-banner-wrapper">
              <div className="blog-banner-container">
                <img src={data.banner && data.banner}></img>
              </div>
            </div>
            <div className="blog-content-wrapper">
              <BlogTitle
                title={data.title}
                date={data.blog_date}
                tag={data.tags}
                margin="0 0 0 16px"
                position="auto"
                spacing="8px 0"
              />
              <SocialMediaShareBar title={data.title} alignLeft={true} />
              {data?.iframe && <BlogIframe innerHtml={data.iframe} />}
              <BlogWysiwyg
                innerHtml={data.description}
                marginMobile="0px 16px"
              />
              {data?.iframe2 && <BlogIframe innerHtml={data.iframe2} />}
              {data?.description2 && data?.description2 !== "<p><br></p>" && (
                <BlogWysiwyg
                  innerHtml={data.description2}
                  marginMobile="0px 16px"
                />
              )}
              {data?.iframe3 && <BlogIframe innerHtml={data.iframe3} />}
              {data?.description3 && data?.description3 !== "<p><br></p>" && (
                <BlogWysiwyg
                  innerHtml={data.description3}
                  marginMobile="0px 16px"
                />
              )}
              {(data.ajukan_button || data.download_button) && (
                <BlogCTA
                  ajukanBtn={data.ajukan_button}
                  downloadBtn={data.download_button}
                  slug={data.slug}
                ></BlogCTA>
              )}
            </div>
          </div>
          <BlogOtherCategory maxWidth="304px"></BlogOtherCategory>
        </div>
      </div>
      <div className="related-article-wrapper">
        <BlogRelatedArticle
          title={data.title}
          tags={data.tags_code}
        ></BlogRelatedArticle>
      </div>
      {winSize > 600 ? (
        <LayoutCenter
          id="sticky-share-socmend"
          style={{ display: "none" }}
          margin="0px"
          position="sticky"
          bottom="0"
          backgroundColor="white"
          width="100%"
          widthLayout="100%"
          boxShadow
          index="0"
        >
          <LayoutCenter margin="0" justifyDesktop="flex-end">
            <p>Bagikan</p>
            <SocialMediaShareBar WidthAuto title={data.title} />
          </LayoutCenter>
        </LayoutCenter>
      ) : (
        ""
      )}
      <style jsx>{`
        .blog-wrapper {
          display: flex;
          align-items: center;
          flex-direction: column;
        }
        .blog-content-container {
          max-width: 1040px;
          display: flex;
          width: 100%;
          justify-content: space-between;
        }
        .blog-banner-container {
          max-width: 688px;
        }
        .blog-banner-wrapper img {
          width: 100%;
        }
        .blog-content-wrapper {
          max-width: 688px;
        }
        .related-article-wrapper {
          display: flex;
          // width: 100%;
          // display: flex;
          /* flex-direction: column; */
          /* width: 100vw; */
          align-items: center;
          justify-content: center;
        }
        .blog-banner-wrapper {
          margin-left: 16px;
        }
        @media only screen and (max-width: 760px) {
          .blog-content-container {
            flex-direction: column;
          }
          .blog-banner-wrapper {
            margin-right: 16px;
          }
        }
      `}</style>
    </Layout>
  );
};

detailBlog.getInitialProps = async ({ res, asPath, query }) => {
  const { blog, prevTitle, prevSlug } = query;

  if (blog.includes(".")) {
    if (res) {
      res.writeHead(301, {
        Location: `/halaman-tidak-ditemukan?k=${blog}`
      });
      res.end();
    }
    return;
  } else {
    const { status, data } = await fetch(
      "GET",
      `/kentico/blog-details`,
      {
        slug: blog
      },
      true
    );
    if (status === 200) {
      const breadcrumb = [
        ...defBreadcrumb,
        {
          "@type": "ListItem",
          position: "2",
          item: {
            "@id": process.env.baseUrl + "/blog",
            name: "Blog"
          }
        },
        {
          "@type": "ListItem",
          position: "3",
          item: {
            "@id": process.env.baseUrl + asPath,
            name: data.title
          }
        }
      ];
      const itemsForBreadCrumb = [
        ...blogBreadcrumb,
        {
          page: prevTitle ? prevTitle : "",
          href: `/blog/${prevSlug}`,
          to: `/blog/${prevSlug}`
        },
        {
          page: data.title,
          href: `/${blog}`,
          to: `/${blog}`
        }
      ];

      return {
        datas: {
          asPath,
          data,
          itemsForBreadCrumb,
          breadcrumb
        }
      };
    } else {
      if (res) {
        res.writeHead(301, {
          Location: `/halaman-tidak-ditemukan?q=${blog}`
        });
        res.end();
      }
      return;
    }
  }
};

export default detailBlog;
